import React from 'react';
import { roundedHumanFormat } from '~/utils/Price/Price';
import { ErpRevenueResponse } from 'com.cogvio.pricemonitor.api';
import { Tooltip } from './Tooltip';

export const calculateModelRevenue = (revenue: ErpRevenueResponse[]) =>
	revenue.reduce(
		(sum: null | number, data) => (data.revenue ? Number(sum || 0) + Number(data.revenue.value) : sum),
		null
	) || NaN;

export const renderModelRevenue = (model: ErpRevenueResponse[], currency: string) => {
	const revenueAggregator = calculateModelRevenue(model);

	return !isNaN(revenueAggregator) ? `${roundedHumanFormat(currency, revenueAggregator.toFixed(2))}` : 'NaN';
};

interface PriceBadgeRevenueProps {
	currency: string;
	cumulativeRevenues: ErpRevenueResponse[];
	type?: 'big' | 'small';
}

export function PriceBadgeRevenue({ currency, cumulativeRevenues, type }: PriceBadgeRevenueProps) {
	const revenue = renderModelRevenue(cumulativeRevenues, currency);
	const isRevenueNaN = revenue === 'NaN';

	return (
		<span
			className={`mr-1 mb-0.5 py-1.5 inline-block font-display text-label leading-none tracking-wider bg-cBlue-400 bg-opacity-10 align-top ${
				type === 'small' ? 'px-2 rounded-sm' : 'px-2.5 rounded'
			}`}
		>
			<span
				className={`text-[10px] leading-4 font-semibold text-gray-500 uppercase ${
					type === 'small' ? 'inline-block pr-1 align-top' : 'block'
				}`}
			>
				Revenue (4Y):
			</span>
			<strong
				className={`font-bold tabular-nums align-top ${
					type === 'small' ? 'inline-block text-[10px] leading-4' : 'block text-[14px] leading-tight'
				} ${isRevenueNaN ? 'inline-block text-gray-400' : 'text-black'}`}
			>
				{revenue}
			</strong>
			{isRevenueNaN && (
				<Tooltip>
					<span className='absolute left-full bottom-0 -mb-0.5 ml-1 px-1.5 py-1 rounded-sm font-display text-label text-white bg-black text-center whitespace-nowrap opacity-0 invisible group-hover:opacity-100 group-hover:visible'>
						Add Volume &amp; Growth data
					</span>
				</Tooltip>
			)}
		</span>
	);
}
